<template>
    <form class="card">
        <h3>Контактные данные</h3>
        <Contacts :data.sync="data"></Contacts>
    </form>
</template>

<script>
    import Contacts from '@/components/forms/Contacts.vue'

    export default {
        props: ['data'],
        components: {
            Contacts
        }
    }
</script>